import React, { FC, ReactNode, useMemo } from "react";
import { View } from "react-native";
import { useI18nMessage } from "@lookiero/i18n-react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon, useScreenSize } from "@lookiero/sty-psp-ui";
import { OfferingsPills } from "../../../../components/offeringsPills/OfferingsPills";
import { DOMAIN, I18nMessages } from "../../../../i18n/i18n";
import { Offering } from "../../../../views/offeringHeader/OfferingHeader";
import { BasketIcon } from "../../../basketIcon/BasketIcon";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";
import { style as offeringHeaderStyle } from "./OfferingHeader.style";

interface OfferingHeaderProps {
  readonly children?: ReactNode;
  readonly hasBasketNotification: boolean;
  readonly offerings: Offering[];
  readonly onPressBasket: () => void;
  readonly onPressWishlist: () => void;
}

const OfferingHeader: FC<OfferingHeaderProps> = ({
  children,
  hasBasketNotification,
  offerings,
  onPressBasket,
  onPressWishlist,
}) => {
  const headerTitleText = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.HEADER_TITLE,
  });

  const screen = useScreenSize();

  const style = useMemo(() => offeringHeaderStyle(), []);

  return (
    <>
      <Header testID="offering-header">
        <View style={style.buttons}>
          <ButtonIconPlaceholder />
          <ButtonIconPlaceholder />
        </View>

        <Text ellipsizeMode="tail" level={3} numberOfLines={1} style={{ flexShrink: 1 }} variant="action">
          {headerTitleText}
        </Text>

        <View style={style.buttons}>
          <ButtonIcon name="heart" testID="wishlist-button" onPress={onPressWishlist} />
          <BasketIcon notification={hasBasketNotification} onPress={onPressBasket} />
        </View>
      </Header>

      <View style={screen !== "L" && style.pills} testID="pills">
        <OfferingsPills offerings={offerings} />
        {children}
      </View>
    </>
  );
};

export { OfferingHeader };
